<template>
  <sb-button
    v-tooltip.top="$t('sbFilter.columnsTooltip')"
    :icon="ColumnsIcon"
    :class="$style.button"
    variation="iconOnly"
    :state="colSelectionActive ? 'active' : undefined"
    data-sb-automation="filter-bar-open-column-selection"
    data-sb-regression="sb-table-columns"
    :pt:icon:class="$style.icon"
    @click="openColumnSelection(true)"
  />
  <template>
    <ColumnsDrawer
      v-model:active="colSelectionActive"
      v-model:appliedColumns="appliedColumns"
      :column-definitions="columnDefinitions"
    />
  </template>
</template>

<script setup>
import { ref, defineModel, defineEmits, defineProps } from 'vue';
import SbButton from '@src/components/Button/SbButton.vue';
import ColumnsIcon from '@public/media/icons/columns.svg';
import ColumnsDrawer from '@src/components/Filter/next/components/SbColumnsDrawer.vue';

const colSelectionActive = ref(false);

const appliedColumns = defineModel('appliedColumns', {
  type: Object,
});
const props = defineProps({
  columnDefinitions: {
    type: Array,
    default: () => [],
  },
});
function openColumnSelection(value) {
  colSelectionActive.value = value;
}

</script>

<style lang='scss' module>
@use '@src/components/Filter/next/styles/sbTableColumns.module.scss';
</style>
